import { createApp } from 'vue'
import App from './App.vue'
import '@/styles/index.scss' // global css
import 'normalize.css/normalize.css'
import '@/assets/fonts/font.css' //字体文件

createApp(App).mount('#app')
